import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    products: null,
    customers: null,
    shouldShowSds: false,
    shouldShowSpec: false,
    brandSelected : !!document.cookie.split('; ').find(cookie => cookie.startsWith('tenant='))
  },
  getters: {
    getProducts: state => state.products,
    getCustomers: state => state.customers,
    getRecentCustomers: state => state.recentCustomers,
    getShouldShowSds: state => state.shouldShowSds,
    getShouldShowSpec: state => state.shouldShowSpec,
    getBrandSelected: state => state.brandSelected
  },
  mutations: {
    updateProducts: (state, product) => {
      state.products = product;
    },
    updateCustomers: (state, customer) => {
      state.customers = customer;
    },
    updateRecentCustomers: (state, customer) => {
      state.recentCustomers = customer;
    },
    updateShouldShowSds: (state, shouldShowSds) => {
      state.shouldShowSds = shouldShowSds;
    },
    updateShouldShowSpec: (state, shouldShowSpec) => {
      state.shouldShowSpec = shouldShowSpec;
    },
    updateBrandSelected: (state, brandSelected) => {
      state.brandSelected = brandSelected
    }
  },
  actions: {
    getProducts: async (context, product) => {
      const { data } = await axios.get('/products');
      context.commit('updateProducts', data);
    },
    getCustomers: async (context, customer) => {
      const { data } = await axios.get('/customers');
      context.commit('updateCustomers', data);
    },
    getCustomersLastYear: async (context, customer) => {
      const { data } = await axios.get('/customers?onlyWithinLastYear=true');
      context.commit('updateRecentCustomers', data);
    },
  },
});
